<template>
  <div class="ordersListPage">
    <div class="ordersOne" v-for="(item, index) in tabledata" :key="item.id">
      <div class="smallimg">
        <img :src="getImageSrc(item.pic)" @click="handleImageClick(item)">
      </div>

      <!-- 使用 v-show 来控制大图的显示和隐藏 -->
      <div class="bigimg" v-if="showBigImg && currentItem === item" @click="handleBigImgClick">
        <div class="big">
          <img :src="getImageSrc(item.pic)">
        </div>
      </div>

      <b>{{ item.name }}</b>
      <i v-if="item.price && item.price > 0">{{ item.price }}灵石</i>
      <div class="dete" @click="handleDelete(item, index)">删除</div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'ordersListOne',
  props: ['tabledata'],
  data() {
    return {
      apip: 'https://www.handingszy.top/uploads/',
      showBigImg: false,     // 控制大图的显示与隐藏
      currentItem: null      // 当前显示的大图对应的item
    };
  },
  watch: {

  },
  components: {

  },
  methods: {
    // 获取图片路径
    getImageSrc(pic) {
      if (pic && pic != null && pic != undefined) {
        // 使用模板字符串直接返回路径，适用于 URL
        return this.apip + pic;
      } else {
        // 异常捕捉，返回默认图片
        return this.apip + 'default.jpg';
      }
    },
    // 点击小图时，显示大图
    handleImageClick(item) {
      this.showBigImg = true;  // 显示大图
      this.currentItem = item;  // 设置当前显示的大图对应的item
    },
    // 点击大图时，隐藏大图
    handleBigImgClick() {
      this.showBigImg = false;  // 隐藏大图
      this.currentItem = null;  // 清空当前显示的大图
    },

    // 删除方法
    handleDelete(item, index) {
      this.$axios.post(`/orders/delete/${item.id}`)
        .then(res => {
          console.log("删除成功")
        })
        .catch(err => {
          console.log(err);
        });
      // location.reload();    //更新页面
      this.tabledata.splice(index, 1); // 通过下标删除，vue自动更新页面
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
// .ordersListPage{
//   width: 100%;
//   height: 100%;
//   padding-bottom: 200rem;
// }
.ordersOne {
  width: 100%;
  height: 200rem;
  font-size: 60rem;
  background-color: rgb(206, 245, 149);
  border-bottom: 2rem solid gray;
  display: flex;
  align-items: center;

  .smallimg {
    width: 150rem;
    height: 150rem;
    margin-left: 25rem;
    overflow: hidden;

    img {
      width: 100%;
    }
  }

  .bigimg {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.4);

    .big {
      position: relative;
      background-color: rgba(212, 212, 212, 0.4);
      margin: 10vh auto;
      border: 1px solid #888;
      border-radius: 20rem;
      width: 80vw;
      height: 80vh;
      z-index: 1001;
      overflow: auto;

      img {
        width: 100%;
      }
    }

    .big::-webkit-scrollbar {
      display: none;
      /* 默认情况下隐藏滚动条 */
    }
  }

  b {
    display: inline-block;
    width: 40vw;
    height: 200rem;
    line-height: 200rem;
    white-space: nowrap;
    overflow: auto;
    margin-left: 50rem;
  }

  b::-webkit-scrollbar {
    display: none;
  }

  i {
    margin-left: 50rem;
  }

  .dete {
    width: 200rem;
    height: 150rem;
    font-size: 80rem;
    text-align: center;
    color: aliceblue;
    background-color: blue;
    border-radius: 20rem;
    border: 5rem solid gray;
    margin-left: auto;
  }
}
</style>